import { Alert, List, Stack, Typography } from "@mui/material";

import { usePriorityRequestActions } from "@/pages/priority-requests/hooks/usePriorityRequestActions";
import { useTranslation } from "@/translations";

import { PriorityRequestsHeader } from "./components/header/PriorityRequestsHeader";
import { PriorityRequestRow } from "./components/row/PriorityRequestRow";
import { usePriorityRequestsWidget } from "./hooks/usePriorityRequestsWidget";

export function PriorityRequestsWidget() {
  const { t } = useTranslation();
  const { priorityRequests, currentCounselorId, selectedCounselorId, onCounselorChange, isError, isEmpty } =
    usePriorityRequestsWidget();
  const actions = usePriorityRequestActions();

  return (
    <Stack flex={1} overflow="hidden" borderRadius={0.5} border={"1px solid"} borderColor={"fsw.blue-10"}>
      <PriorityRequestsHeader
        count={priorityRequests.length}
        currentCounselorId={currentCounselorId}
        selectedCounselorId={selectedCounselorId}
        onCounselorChange={onCounselorChange}
      />

      {isError && (
        <Alert severity="error" sx={{ m: 2 }}>
          {t("priorityRequests.error")}
        </Alert>
      )}

      {isEmpty && (
        <Typography color="text.secondary" role="status" px={2} py={1.5}>
          {t("priorityRequests.widget.empty")}
        </Typography>
      )}

      <List disablePadding sx={{ overflowY: "auto", flex: 1 }}>
        {priorityRequests.map((priorityRequest) => (
          <PriorityRequestRow key={priorityRequest.clientId} priorityRequest={priorityRequest} actions={actions} />
        ))}
      </List>
    </Stack>
  );
}
